// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1fww9","notes":"Notes_notes__3CoOE","note":"Notes_note__1sLO7","markdown":"Notes_markdown__B6Y-h"};